//// .Net generated code


//// BadgeComplianceGridCategoryEnum
export enum BadgeComplianceGridCategoryEnum {
    AllCategories= 0,
    PreHire= 1,
    Employee= 2,
    ThirdPartyContractor= 3,
    MemberFirm= 4,
    NonDeloitte= 5,
    FullTimeEmployee= 6,
    ContractorsOrInters= 7,
    BadgeExtension= 8
}

//// BadgeReasonEnum
export enum BadgeReasonEnum {
    BadgeDamaged= 1,
    BadgeLost= 2,
    BadgeStolen= 3,
    InitialBadgeRequest= 4,
    PhotoOnly= 5,
    PhotoCompliance= 6,
    BadgeExtension= 7
}

//// BadgeRequestCategoryEnum
export enum BadgeRequestCategoryEnum {
    PreHire= 1,
    Employee= 2,
    ThirdPartyContractor= 3,
    MemberFirm= 4,
    NonDeloitte= 5,
    FullTimeEmployee= 6,
    ContractorsOrInterns= 7,
    CleContractor= 8
}

//// BadgeRequestTypeEnum
export enum BadgeRequestTypeEnum {
    Default= 1,
    MissingPhoto= 2,
    Resubmission= 3
}

//// BadgeStatusEnum
export enum BadgeStatusEnum {
    Pending= 1,
    Printing= 2,
    CreatedInTransfer= 3,
    ReadyToPickUp= 4,
    Provided= 5,
    ShippedTo= 7,
    Transfer= 8,
    Termed= 9,
    ApprovalNeeded= 10,
    ApprovedByManager= 11,
    DeclinedByManager= 12,
    DeclinedByBadgingOfficer= 13,
    ReadyForPrinting= 14,
    IrcApproved= 15,
    IrcDeclined= 16,
    ApprovedBySeniorManager= 17,
    DeclinedBySeniorManager= 18,
    LostInTransit= 19,
    PendingPhotoCompliance= 20,
    PhotoCompliant= 21
}

//// CleBadgeTypeEnum
export enum CleBadgeTypeEnum {
    New= 0,
    Extension= 1
}

//// ColumnFilterTypeEnum
export enum ColumnFilterTypeEnum {
    None= 0,
    General= 1,
    Tag= 2,
    DateTimeRange= 3,
    Text= 4
}

//// CroppEngine
export enum CroppEngine {
    Draw= 0,
    Magick= 1,
    SixLabors= 2,
    ImageProcessor= 3
}

//// DocumentTypeEnum
export enum DocumentTypeEnum {
    Passport= 1,
    FrontFace= 2,
    Signature= 3,
    Attachment= 4
}

//// MemberFirmVisitorVisaTypeEnum
export enum MemberFirmVisitorVisaTypeEnum {
    Business= 1,
    EBusiness= 2,
    ETourist= 3,
    Employment= 4,
    Resident= 5,
    Tourist= 6
}

//// MemberFirmVisitorVisitReasonEnum
export enum MemberFirmVisitorVisitReasonEnum {
    DeliverAttendInternalTrainings= 1,
    ExternalClientMeetings= 2,
    InternalTeamMeetings= 3,
    ParticipateInExternalTrainings= 4,
    PerformClientBillableWork= 5,
    SeminarsOrConferences= 6,
    SupervisingClientBillableWork= 7
}

//// MobileBadgeStatusEnum
export enum MobileBadgeStatusEnum {
    Pending= 1,
    Approved= 2,
    Provisioned= 3,
    Canceled= 4
}

//// MobileDeviceStatusEnum
export enum MobileDeviceStatusEnum {
    NotPushed= 1,
    Pushing= 2,
    Pushed= 3
}

//// MobileRequestReasonEnum
export enum MobileRequestReasonEnum {
    InitialBadge= 1,
    LostPhone= 2,
    WeeklyTraveler= 3
}

//// NonDeloittePurposeOfVisitEnum
export enum NonDeloittePurposeOfVisitEnum {
    AuditAssessment= 1,
    BusinessVisit= 2
}

//// NonDeloitteTypeOfVisitEnum
export enum NonDeloitteTypeOfVisitEnum {
    Client= 1,
    GovernmentOfficial= 2,
    Trainer= 3,
    Others= 4
}

//// NotificationTypeEnum
export enum NotificationTypeEnum {
    PrehirePhotoUpload= 1,
    PrehireOutOfCompliance= 3,
    PrehireBadgePickUp= 4,
    EmployeeOutOfCompliance= 5,
    EmployeeBadgePickUp= 6,
    PrehireWelcome= 7,
    MissingPhoto= 8,
    BadgeStolenDamagedLost= 9,
    VisitorBadgeCreated= 10,
    VisitorBadgeReadyForApprove= 11,
    VisitorBadgeDeclined= 12,
    VisitorBadgePickUp= 13,
    BadgeDeclined= 14,
    BadgeDeactivated= 15
}

//// OldAccessCardDeactivatedEnum
export enum OldAccessCardDeactivatedEnum {
    Yes= 1,
    No= 2
}

//// PeoplePickerPhoneTypeEnum
export enum PeoplePickerPhoneTypeEnum {
    OfficePhone= 2,
    MobilePhone= 8
}

//// PersonaTypeEnum
export enum PersonaTypeEnum {
    MemberFirm= 1,
    NonDeloitte= 2,
    ThirdPartyContractor= 3
}

//// PhotoStatusEnum
export enum PhotoStatusEnum {
    MissingNotProvided= 1,
    ApprovalPending= 2,
    FurtherReview= 3,
    Approved= 4,
    ResubmissionPending= 5,
    OfferRescindedRejected= 6,
    Cancelled= 7,
    NoActionRequired= 8
}

//// ReIssueBadgeReasonEnum
export enum ReIssueBadgeReasonEnum {
    Damaged= 1,
    Lost= 2,
    Stolen= 3
}

//// RejectedPhotoReasonEnum
export enum RejectedPhotoReasonEnum {
    PhotoIsPixelatedOrBlurry= 1,
    PhotoIsTooLarge= 2,
    PhotoIsTooSmall= 3,
    FacialExpressionInappropriateOrEyesClosed= 5,
    PhotoshoppedFilteredPhotoOrPhotoIsTooDark= 6,
    SunglassesOrHatOnIndividual= 7,
    NotFacingForward= 8,
    PhotoIsBlackAndWhite= 9,
    PhotoTakenInLandscapePerspective= 10,
    BackgroundInappropriateIncorrect= 11,
    PhotoIsNotOfIndividual= 12
}

//// RequestListGridCategoryEnum
export enum RequestListGridCategoryEnum {
    MyRequests= 0,
    VisitorRequests= 1,
    Contractors= 2,
    BadgeExtension= 3,
    CleContractors= 4
}

//// RoleCategoryEnum
export enum RoleCategoryEnum {
    PreHire= 1,
    Employee= 2,
    Contractor= 3
}

//// SaveEmployeeActionEnum
export enum SaveEmployeeActionEnum {
    Add= 1,
    Save= 2
}

//// UserCountriesEnum
export enum UserCountriesEnum {
    UnitedStates= 1,
    India= 2,
    Mexico= 3,
    CostaRica= 4
}

//// UserRoleEnum
export enum UserRoleEnum {
    PreHire= 1,
    Csba= 2,
    FTE= 3,
    Employee= 4,
    FrontDesk= 5,
    Security= 6,
    Facilitator= 7,
    SeniorManager= 8,
    CTH= 9,
    EchoPartner= 10,
    IRCApprover= 11,
    ThirdPartyContractorApprover= 12,
    CLE= 13
}

//// VisitorType
export enum VisitorType {
    NonDeloitteVisitor= 0,
    MemberFirmVisitor= 1
}

